import {
  addDays,
  addHours,
  addMinutes,
  addSeconds,
  addYears,
  subDays,
  subHours,
  subMinutes,
  subSeconds,
  subYears,
} from 'date-fns';
import { TIME_FILTER_DATE_STRING } from '../constants';

export const parseMinMaxDateTimeValue = (
  dateString: string,
  timeOnly = false
) => {
  const newMinValue = new Date(
    timeOnly ? `${TIME_FILTER_DATE_STRING}${dateString}` : dateString
  );
  if (newMinValue.getDate()) {
    return newMinValue;
  } else {
    const lastSymbol = dateString.slice(-1);
    const firstSymbol = dateString.slice(0, 1);
    const value = Number(dateString.slice(1, -1));
    if (
      ['-', '+'].includes(firstSymbol) &&
      ['s', 'm', 'h', 'd', 'y'].includes(lastSymbol) &&
      !isNaN(value)
    ) {
      const date = new Date();
      const positive = firstSymbol === '+';
      switch (lastSymbol) {
        case 's':
          return positive ? addSeconds(date, value) : subSeconds(date, value);
        case 'm':
          return positive ? addMinutes(date, value) : subMinutes(date, value);
        case 'h':
          return positive ? addHours(date, value) : subHours(date, value);
        case 'd':
          return positive ? addDays(date, value) : subDays(date, value);
        case 'y':
          return positive ? addYears(date, value) : subYears(date, value);
        default:
          return null;
      }
    }
    return null;
  }
};
